// styling
import styled from "styled-components/macro";
// components
import StyledModal from "@ui/StyledModal";
import itemsGridItemStyles from "@components/ItemsGrid/ItemsGridItem/style.module.scss";
import itemsGridStyles from "@components/ItemsGrid/style.module.scss";

// hooks
import { useForm } from "react-hook-form";
// utils
import { useEffect, useState } from "react";
import classNames from "classnames";
import { ClipLoader } from "react-spinners";
import api from "@utils/api";
import { Typography } from "@mui/material";

const ImageSelector = ({ addImage, imagesLayers }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [userImages, setUserImages] = useState([]);

  const token = localStorage.getItem("token");
  const [backendErrors, setBackendErrors] = useState({});

  const handleImageClick = (id, image) => {
    const [width, height] = image?.imgRes?.split("x");
    const ratio = parseFloat(width) / parseFloat(height);
    // If id doesn't exist, add it to the array
    addImage(image, ratio);
    // }
  };
  // console.log(imagesId);

  useEffect(() => {
    setIsLoading(true);
    const headers = { Authorization: `Bearer ${token}` };
    api
      .get("/get-selected-images", { headers })
      .then((res) => {
        setIsLoading(false);
        const userImages = res?.data?.data;
        // console.log(userImages);
        const imageData = userImages?.map((img) => ({
          image: img.image,
          imgRes: img.image_size,
          id: img.id,
        }));
        setUserImages(imageData);
      })
      .catch((error) => {
        if (error.response) {
          const errorData = error?.response?.data;
          const backend = {};
          if (errorData.messages) {
            backend.messages = errorData?.messages[0]?.message;
          }
          if (errorData.error) {
            backend.error = errorData?.error;
          }
          setBackendErrors(backend);
          setIsLoading(false);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log("Error: ", error?.message);
        }
      });
  }, []);

  return (
    <div
      className="d-flex flex-column g-20"
      style={{
        marginBottom: "10px",
      }}
    >
      {/* <h6 className="content_title">User Images</h6> */}
      <div className="container">
        {userImages.length > 0 ? (
          <>
            <div
              style={{
                // height: "300px",
                overflowX: "auto",
                display: "flex",
                flexDirection: "row",
              }}
            >
              {isLoading === false ? (
                <>
                  {userImages?.map((image) => (
                    <div
                      style={{
                        margin: "10px",
                        display: "flex",
                        cursor: "pointer",
                      }}
                      className={`${itemsGridItemStyles.wrapper} ${
                        imagesLayers.some((layer) => {
                          return layer.attrs.id === image.id;
                        })
                          ? "border-selected"
                          : "border-hover"
                      }  bg-primary`}
                      onClick={() => {
                        handleImageClick(image.id, image);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            objectFit: "contain",
                            width: "150px",
                            height: "150px",
                          }}
                          src={image.image}
                         // src={`http://127.0.0.1:8000${image.image}`}
                          alt="Item Img"
                        />
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <h4
                    style={{
                      textAlign: "center",
                      margin: "360px 0px 360px 0px",
                    }}
                  >
                    <ClipLoader color="#ffffff" size={50} />
                  </h4>
                </>
              )}
            </div>
          </>
        ) : (
          <Typography
            style={{
              textAlign: "center",
            }}
          >
            No images in canvas. Please add to create comic.
          </Typography>
        )}
      </div>
    </div>
  );
};

export default ImageSelector;
